import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const aedSaleLocaleModule: LocaleModule = {
  name: "aedSale",
  messages: { en: en, it: it },
};
